// extracted by mini-css-extract-plugin
module.exports = {"name":"FilterSection_name__jf6u7","arrow":"FilterSection_arrow__qH7pS","arrowExpanded":"FilterSection_arrowExpanded___XAdS"};